



































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import LoadingBar from "@c/atoms/app/LoadingBar.vue";

@Component({
  name: "ConfirmDialog",

  components: {
    LoadingBar
  }
})
export default class ConfirmDialog extends Vue {
  @Prop(Boolean) show?: boolean;
  @Prop(String) text?: string;
  @Prop(String) cancel?: string;
  @Prop(String) confirm?: string;
  @Prop({ default: "primary" }) confirm_color?: string;
  @Prop({ default: false }) loading?: boolean;
}
